export const DASHBOARD = 'Dashboard - Simplified Society Management App';
export const LOGIN = 'SocietyXpert - Simplified Society Management App';